import {
  FETCH_LOGIN_ATTEMPTS,
  FETCH_LOGIN_ATTEMPTS_SUCCESS,
  FETCH_LOGIN_ATTEMPTS_ERROR,
  FETCH_BLOCKED_LIST,
  FETCH_BLOCKED_LIST_SUCCESS,
  FETCH_BLOCKED_LIST_ERROR,
  FETCH_LOGIN_STATS,
  FETCH_LOGIN_STATS_SUCCESS,
  FETCH_LOGIN_STATS_ERROR,
  UNBLOCK_IP,
  UNBLOCK_IP_SUCCESS,
  UNBLOCK_IP_ERROR,
  UNBLOCK_EMAIL,
  UNBLOCK_EMAIL_SUCCESS,
  UNBLOCK_EMAIL_ERROR,
  SET_FILTER
} from './types';

const API_URL = process.env.REACT_APP_API_URL || '';

// Fetch login attempts
export const fetchLoginAttempts = (filters = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_LOGIN_ATTEMPTS });

    try {
      // Build query string from filters
      const queryParams = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key] !== undefined && filters[key] !== '') {
          queryParams.append(key, filters[key]);
        }
      });

      const response = await fetch(`${API_URL}/api/admin/login-attempts?${queryParams.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch({
        type: FETCH_LOGIN_ATTEMPTS_SUCCESS,
        payload: data
      });

      return data;
    } catch (error) {
      dispatch({
        type: FETCH_LOGIN_ATTEMPTS_ERROR,
        payload: error.message
      });
      throw error;
    }
  };
};

// Fetch blocked list
export const fetchBlockedList = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_BLOCKED_LIST });

    try {
      const response = await fetch(`${API_URL}/api/admin/login-attempts/blocked`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch({
        type: FETCH_BLOCKED_LIST_SUCCESS,
        payload: data
      });

      return data;
    } catch (error) {
      dispatch({
        type: FETCH_BLOCKED_LIST_ERROR,
        payload: error.message
      });
      throw error;
    }
  };
};

// Fetch login stats
export const fetchLoginStats = (hours = 24) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_LOGIN_STATS });

    try {
      const response = await fetch(`${API_URL}/api/admin/login-attempts/stats?hours=${hours}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch({
        type: FETCH_LOGIN_STATS_SUCCESS,
        payload: data
      });

      return data;
    } catch (error) {
      dispatch({
        type: FETCH_LOGIN_STATS_ERROR,
        payload: error.message
      });
      throw error;
    }
  };
};

// Unblock IP address
export const unblockIP = (ipAddress) => {
  return async (dispatch) => {
    dispatch({ type: UNBLOCK_IP });

    try {
      const response = await fetch(`${API_URL}/api/admin/login-attempts/unblock/ip/${encodeURIComponent(ipAddress)}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch({
        type: UNBLOCK_IP_SUCCESS,
        payload: { ...data, ip_address: ipAddress }
      });

      // Refresh blocked list
      dispatch(fetchBlockedList());

      return data;
    } catch (error) {
      dispatch({
        type: UNBLOCK_IP_ERROR,
        payload: error.message
      });
      throw error;
    }
  };
};

// Unblock email address
export const unblockEmail = (emailAddress) => {
  return async (dispatch) => {
    dispatch({ type: UNBLOCK_EMAIL });

    try {
      const response = await fetch(`${API_URL}/api/admin/login-attempts/unblock/email/${encodeURIComponent(emailAddress)}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch({
        type: UNBLOCK_EMAIL_SUCCESS,
        payload: { ...data, email: emailAddress }
      });

      // Refresh blocked list
      dispatch(fetchBlockedList());

      return data;
    } catch (error) {
      dispatch({
        type: UNBLOCK_EMAIL_ERROR,
        payload: error.message
      });
      throw error;
    }
  };
};

// Set filter
export const setFilter = (filterName, filterValue) => {
  return {
    type: SET_FILTER,
    payload: { filterName, filterValue }
  };
};